var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"wangEditor"}},[_c('div',{ref:"editorElem",on:{"keydown":function($event){return _vm.textChange($event)},"keyup":function($event){return _vm.textChange($event)}}})])}
var staticRenderFns = []

export { render, staticRenderFns }